module.exports = __webpack_public_path__ + "static/media/tooltip-arrow.c9e9fb90.svg";